import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { ReactComponent as ValidIcon } from "../../images/check_marker_green.svg";
import { ReactComponent as InvalidIcon } from "../../images/cross_cricle_red.svg";
import styles from "./TestApiModal.module.css";
import { AuthenticationApiCalls } from "../../apis/AuthenticationApiCalls";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import {
    BUTTON,
} from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import { YuJaTextBox } from "../standardization/YuJaTextBox";
import { Spin } from "../../components/standardization/YuJaLoading";

export default function TestApiModal({show, onClose, intType}) {
    const { t } = useTranslation();
    const [, getSession] = useLocalStorageNew("session", {});
    const {testLmsApiAccess} = AuthenticationApiCalls();

    const [courseId, setCourseId] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        if (show) {
            setCourseId(getSession().tpCourseId || "");
            setResult(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const handleTestApi = () => {
        if (!courseId.trim() || loading) {
            return;
        }
        setLoading(true);
        setResult(null);
        testLmsApiAccess(intType, courseId.trim()).then(res => {
            setResult(res);
            setLoading(false);
        });
    };

    return (
        <Modal
            id="test-api-modal"
            show={show}
            onHide={onClose}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName={styles.dialog}
        >
            <ModalClose tabIndex={0} aria-label={t("accessibility.closeModal")} role={BUTTON} onClick={onClose} className="modal-close" />
            <Modal.Header style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Modal.Title aria-label={t("integration.testApiModalTitle") + t("accessibility.modalSuffix")} className={styles.title} id="contained-modal-title-vcenter">
                    {t("integration.testApiModalTitle")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.container}>
                    <div className={styles.description}>
                        {t("integration.testApiModalDescription")}
                    </div>

                    {loading 
                        ?
                        <div className={styles.spinnerRow}>
                            <Spin spinning={true} size="large" overlay={false} />
                        </div>
                        :
                        (
                            result 
                            ?
                            <div className={styles.container}>
                                <div className={styles.resultRow}>
                                    {result.courseCheck?.passed ? <ValidIcon /> : <InvalidIcon />}
                                    <div>
                                        <div className={styles.resultRowTitle}>{t("integration.testApiCourseInfoTitle")}</div>
                                        <div className={styles.resultRowDescription}>{t("integration.testApiCourseInfoDescription")}</div>
                                    </div>
                                </div>
                                <div className={styles.resultRow}>
                                    {result.rosterCheck?.passed ? <ValidIcon /> : <InvalidIcon />}
                                    <div>
                                        <div className={styles.resultRowTitle}>{t("integration.testApiCourseRosterTitle")}</div>
                                        <div className={styles.resultRowDescription}>{t("integration.testApiCourseRosterDescription")}</div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className={styles.fieldGroup}>
                                <div className={styles.fieldLabel}>{t("integration.testApiCourseIdLabel")}</div>
                                <div className={styles.testRow}>
                                    <YuJaTextBox
                                        placeholder={t("integration.testApiCourseIdPlaceholder")}
                                        name="courseId"
                                        label={t("integration.testApiCourseIdLabel")}
                                        value={courseId}
                                        onChange={(e) => setCourseId(e.target.value)}
                                        containerStyle={{marginBottom: 0, flex: 1}}
                                    />
                                    <YuJaButton onClick={handleTestApi} disabled={!courseId.trim() || loading} size="large">
                                        {t("integration.testApiButtonText")}
                                    </YuJaButton>
                                </div>
                            </div>
                        )

                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton type="secondary" onClick={onClose}>
                    {t("common.cancel")}
                </YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}
